// Entry for chat widget iframe.

import { BotFlow } from '../../chatbot/botFlow.js';
import { chatWidget } from '../chatWidget.js';
import chatWidgetControl from '../chatWidgetControl.js';
import patronSession from '../models/PatronSession.js';

/**
 *
 * @param {Object} settings Widget settings.
 * @param {Object} sessionData Patron session data.
 * @param {String} cascadeServer Domain for chat.
 * @param {String} socketIoUrl Url to socket.io library.
 * @param {Array} departments Chat department data
 * @param {Object} flowData Bot flow settings.
 * @param {String} altCascadeServer Stage/dev test domain for chat.
 */
window.initWidget = function ({
    settings,
    sessionData,
    cascadeServer,
    socketIoUrl,
    departments,
    flowdata,
    altCascadeServer,
}) {
    const patron = Object.create(patronSession);
    patron.init(sessionData);

    const widget = Object.create(chatWidget);
    widget.initialize(settings);
    const flow = new BotFlow(flowdata);

    const controller = Object.create(chatWidgetControl);
    controller.init(widget, patron, cascadeServer, socketIoUrl, departments, flow, altCascadeServer);
};
